import React from "react";

export default function OpticPickerIcon({
  size = 100,
  ariaLabel = "OpticPicker logo",
  colors = {
    accent: "#3b82f6",
    cubeTop: "#6b6f75",
    cubeLeft: "#4b4f54",
    cubeEdge: "#23262a",
    reticle: "#ffffff",
    dot: "#e03636",
  },
}) {
  const { accent, cubeTop, cubeLeft, cubeEdge, reticle, dot } = colors;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <title>{ariaLabel}</title>

      {/* Optional: Adds a realistic glow to the red dot */}
      <defs>
        <filter id="dotGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* Cube - Isometric structure */}
      <polygon points="256,56 384,120 256,184 128,120" fill={cubeTop} />
      <polygon points="128,120 256,184 256,312 128,248" fill={cubeLeft} />
      <polygon points="256,184 384,120 384,248 256,312" fill={accent} />

      {/* Base Edge */}
      <rect
        x="244"
        y="312"
        width="24"
        height="8"
        fill={cubeEdge}
        opacity="0.9"
      />

      {/* Reticle - Now perfectly centered at the cube's face intersection (256, 184) */}
      <g transform="translate(256,184)">
        {/* Outer Circle */}
        <circle
          cx="0"
          cy="0"
          r="86"
          fill="none"
          stroke={reticle}
          strokeWidth="14"
          strokeLinecap="round"
        />

        {/* Horizontal Crosshairs */}
        <line
          x1="-110"
          y1="0"
          x2="-28"
          y2="0"
          stroke={reticle}
          strokeWidth="14"
          strokeLinecap="square"
        />
        <line
          x1="28"
          y1="0"
          x2="110"
          y2="0"
          stroke={reticle}
          strokeWidth="14"
          strokeLinecap="square"
        />

        {/* Vertical Crosshairs */}
        <line
          x1="0"
          y1="-110"
          x2="0"
          y2="-28"
          stroke={reticle}
          strokeWidth="14"
          strokeLinecap="square"
        />
        <line
          x1="0"
          y1="28"
          x2="0"
          y2="110"
          stroke={reticle}
          strokeWidth="14"
          strokeLinecap="square"
        />

        {/* Center Post Background */}
        <rect x="-8" y="-6" width="16" height="12" fill={reticle} />
        <rect x="-6" y="-8" width="12" height="16" fill={reticle} />

        {/* The Red Dot - With Glow Filter */}
        <circle cx="0" cy="0" r="10" fill={dot} filter="url(#dotGlow)" />
      </g>
    </svg>
  );
}
